import { useState } from 'react';
import type { Game } from '../../shared/types';
import { atlasCover } from '../atlas-presentation';
import { GameArt } from './GameCard';
import { ResponsiveImage } from './ResponsiveImage';
import { ATLAS_CARD_SIZES } from '../../shared/image-delivery';
export function AtlasArt({
  game,
  className = '',
  sizes = ATLAS_CARD_SIZES,
}: {
  game: Game;
  className?: string;
  sizes?: string;
}) {
  const src = atlasCover(game);
  const [failed, setFailed] = useState('');
  return src && failed !== src ? (
    <div className={`game-art ${className}`}>
      <ResponsiveImage
        src={src}
        sizes={sizes}
        alt=""
        loading="lazy"
        decoding="async"
        onError={() => setFailed(src)}
      />
    </div>
  ) : (
    <GameArt game={game} className={className} sizes={sizes} />
  );
}
